export enum SettingsResourceTypes {
  WORKING_SCHEDULE_RESOURCE = 'working_schedule',
  CLINIC_RESOURCE = 'clinic',
  LIST_RESOURCE = 'list',
  NOTIFICATION_RESOURCE = 'notification',
  FACILITY_RESOURCE = 'facility',
  DEVICE = 'device',
  USER = 'user',
}

export enum AccessManagemetResourceTypes {
  TRACKING_ACCESS_RESOURCE = 'tracking',
  DOCUMENTS_ACCESS_RESOURCE = 'documents',
  LOGGING_ACCESS_RESOURCE = 'logging',
  GROUP_RESOURCE = 'group',
  RESOURCE_ROLE_RESOURCE = 'system_role',
  SYSTEM_ROLE_RESOURCE = 'resource_role',
}

export enum SurgicalLogsResourceTypes {
  LOGS_RESOURCE = 'logs',
  LOG_RESOURCE = 'log',
  CATEGORY_RESOURCE = 'category',
  ORDERS_RESOURCE = 'orders',
  ENTRY_RESOURCE = 'entry',
}

export enum TrackingResourceTypes {
  TABLE_RESOURCE = 'table',
  FOLDER_RESOURCE = 'folder',
  ENTRY_TYPE_RESOURCE = 'entry_type',
  ASSESSORS_RESOURCE = 'assessors',
  ENTRY_RESOURCE = 'entry',
}

export enum DocumentsResourceTypes {
  REMINDER_RESOURCE = 'reminder',
  POSITION_RESOURCE = 'position',
  DOCUMENT_RESOURCE = 'document',
  PROFILE_RESOURCE = 'profile',
  CONTRACT_RESOURCE = 'contract',
  USER = 'user',
}

export enum AccreditationsResourceTypes {
  STANDARD_RESOURCE = 'standard',
}

export enum PoliciesResourceTypes {
  POLICY_RESOURCE = 'policy',
}

export enum AuditsResourceTypes {
  AUDIT_RESOURCE = 'audit',
}
